module.exports = __webpack_public_path__ + "img/fraishead-70.96c9d1b9.jpg";